import React from "react";
import { Link } from "react-router-dom";

// App Store
import apple_store from '../../../assets/images/app_store/apple_store.svg';
import play_store from '../../../assets/images/app_store/play_store.svg';
import oneLinkQRCode from '../../../../src/components/Pages/Campaign/onelinkQRcod.png';
// Social Icons
import facebook from '../../../assets/images/icon/social_icons/facebook.svg';
import twitter from '../../../assets/images/icon/social_icons/twitter.svg';
import linkedin from '../../../assets/images/icon/social_icons/linkedin.svg';
import instagram from '../../../assets/images/icon/social_icons/insta.svg';
import youtube from '../../../assets/images/icon/social_icons/youtube.svg';
import telegram from '../../../assets/images/icon/social_icons/telegram.svg';

// Divider
import divider from "../../../assets/images/miscellanous/footer_divider.svg";

// Data
import { data } from "../../Data";

const companyLinks = [
  { text: "Privacy Policy", link: "/privacy-policy" },
  { text: "Terms of service", link: "/term-of-service" },
];

const socialMedia = [
  { text: 'Facebook', link: 'https://www.facebook.com/investment-advisory/', icon: facebook },
  { text: 'X', link: 'https://x.com/researchandrank/', icon: twitter },
  { text: 'Linkedin', link: 'https://www.linkedin.com/company/10424180/admin/', icon: linkedin },
  { text: 'Instagram', link: 'https://www.instagram.com/equentis/', icon: instagram },
  { text: 'Youtube', link: 'https://www.youtube.com/channel/UC-U06u6qrxWfCTL3CT0_39w', icon: youtube },
  { text: 'Telegram', link: 'https://t.me/researchandranking', icon: telegram },
];

const contactInformation = [
  <div key="contactno" className="flex items-center space-x-4 mb-5">
    <div className="bg-white rounded-full w-9 h-9 flex items-center justify-center flex-shrink-0">
      <svg className="w-5 h-5 text-[#001D4A]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
    </div>
    <span className="text-[15px] font-bold text-white">+91 22 61013888</span>
  </div>,
  <div key="email" className="flex items-center space-x-4 mb-5">
    <div className="bg-white rounded-full w-9 h-9 flex items-center justify-center flex-shrink-0">
      <svg className="w-5 h-5 text-[#001D4A]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
    </div>
    <a href="mailto:support.informedinvestorr@equentisedutech.com" className="text-[15px] text-gray-300 hover:text-white transition-colors">
      support.informedinvestorr@equentisedutech.com
    </a>
  </div>,
  <div key="address" className="flex items-start space-x-4">
    <div className="bg-white rounded-full w-9 h-9 flex items-center justify-center flex-shrink-0 mt-1">
      <svg className="w-5 h-5 text-[#001D4A]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
    </div>
    <div className="text-[15px] text-gray-400 leading-relaxed font-normal">
      <strong className="text-white block mb-0.5">Equentis Edutech Limited</strong>
      A-703, Marathon Futurex, 7th Floor, Mafatlal Mills<br />
      Compound, Delisle Road, Mumbai 400013, Maharashtra, India.
    </div>
  </div>
];

const FooterSection1 = () => {
  return (
    <>
      <div className="bg-footer-primary text-white py-16 px-6 md:px-12 lg:px-20 font-inter">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row gap-16 lg:gap-24">
          
          {/* Left Column */}
          <div className="lg:w-[45%] flex flex-col pt-2">
            <div className="mb-10">
              <img
                src={`${data.ec2}equentis_footer_logo.svg`}
                alt="Equentis Logo"
                className="w-56 object-contain mb-4"
              />
              <p className="text-white font-bold tracking-wide text-lg">#KnowledgeMeinEDGEHain</p>
            </div>
            
            <div className="flex flex-col mt-2">
              {contactInformation}
            </div>
          </div>
          
          {/* Right Column Grid */}
          <div className="lg:w-[55%] flex flex-col">
            
            {/* Top CIN Row */}
            <div className="mb-14 text-[15px] text-gray-400 pb-2 hidden lg:block">
              <strong className="text-white">Corporate Identification Number (CIN):</strong> U85490MH2024PLC432104
            </div>

            {/* Sub-grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-10 lg:gap-6">
              
              {/* Company Links */}
              <div className="lg:col-span-2">
                <h4 className="font-bold text-lg mb-6 text-white">Company</h4>
                <ul className="space-y-4 text-[15px] text-gray-400 font-medium">
                  {companyLinks.map((link, index) => (
                    <li key={index}>
                      <Link to={link.link} className="hover:text-white transition-colors">{link.text}</Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Socials & Apps */}
              <div className="lg:col-span-3">
                <div className="mb-8">
                  <h4 className="font-bold text-[15px] mb-4 text-white">Follow us</h4>
                  <div className="flex gap-2">
                    {socialMedia.map((social, index) => (
                      <a key={index} href={social.link} className="w-[34px] h-[34px] hover:opacity-80 transition-opacity flex items-center justify-center">
                        <img src={social.icon} alt={social.text} className="w-full h-full object-contain" />
                      </a>
                    ))}
                  </div>
                </div>

                <div>
                  <h4 className="font-bold text-[15px] mb-4 text-white">Download The App On Mobile</h4>
                  <div className="flex gap-4">
                    <a href={data.google_play_store || '#'} className="hover:opacity-80 transition-opacity">
                      <img src={play_store} alt="Google Play" className="h-[42px] object-contain" />
                    </a>
                    <a href={data.apple_store || '#'} className="hover:opacity-80 transition-opacity">
                      <img src={apple_store} alt="App Store" className="h-[42px] object-contain" />
                    </a>
                  </div>
                </div>
              </div>

              {/* QR Code */}
              <div className="lg:col-span-1 flex justify-start lg:justify-end">
                <div className="bg-white p-2.5 rounded-xl self-start shadow-xl">
                  <img src={oneLinkQRCode} alt="QR Code" className="w-[124px] h-[124px] min-w-[124px]" />
                </div>
              </div>
            </div>
            
            {/* Mobile CIN Row */}
            <div className="mt-12 text-[15px] text-gray-400 pt-6 border-t border-white/10 block lg:hidden">
              <strong className="text-white">Corporate Identification Number (CIN):</strong> U85490MH2024PLC432104
            </div>

          </div>
        </div>
      </div>
      <img src={divider} alt="divider" className="w-full h-auto object-cover opacity-80" />
    </>
  );
};

export default FooterSection1;
